"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchPaymentsSaga = fetchPaymentsSaga;
exports.fetchPaymentMethodsSaga = fetchPaymentMethodsSaga;
exports.fetchPaymentAccountsSaga = fetchPaymentAccountsSaga;
exports.createPaymentSaga = createPaymentSaga;
exports.fetchWithdrawalsSaga = fetchWithdrawalsSaga;
exports.fetchWithdrawalMethodsSaga = fetchWithdrawalMethodsSaga;
exports.createWithdrawalSaga = createWithdrawalSaga;
exports.createWithdrawalSuccessSideEffectsSaga = createWithdrawalSuccessSideEffectsSaga;
exports.withdrawVerificationIdentifierErrorSaga = withdrawVerificationIdentifierErrorSaga;
exports.BalanceProviderSaga = BalanceProviderSaga;
const effects_1 = require("redux-saga/effects");
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const slice_1 = require("../AccountProvider/slice");
const selectors_1 = require("../AccountProvider/selectors");
const selectors_2 = require("./selectors");
const format_1 = require("../../utils/format");
const env_1 = require("../../utils/env");
const types_1 = require("./types");
const constants_1 = require("./constants");
const selectors_3 = require("../LanguagesProvider/selectors");
const types_2 = require("../ConfigProvider/types");
const selectors_4 = require("../ConfigProvider/selectors");
const api_1 = require("../../api");
const errors_1 = require("../../utils/errors");
const slice_2 = require("./slice");
const selectors_5 = require("./selectors");
const utils_1 = require("./utils");
function* fetchPaymentsSaga(action) {
    try {
        const paymentsApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.PaymentsApi);
        const { data: resData } = yield (0, effects_1.call)(() => paymentsApi.getPayments(action.payload));
        yield (0, effects_1.put)(slice_2.balanceProviderActions.fetchPaymentsSuccess(resData));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        yield (0, effects_1.put)(slice_2.balanceProviderActions.fetchPaymentsError(error));
    }
}
function* fetchPaymentMethodsSaga(action) {
    try {
        const paymentsApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.PaymentsApi);
        const currentLangCode = yield (0, effects_1.select)(selectors_3.selectCurrentLangCode);
        const accountId = yield (0, effects_1.select)(selectors_1.selectAccountId);
        const reqPayload = { locale: currentLangCode, accountId };
        const { data: resData } = yield (0, effects_1.call)(() => paymentsApi.getPaymentMethods({ ...action.payload, ...reqPayload }));
        yield (0, effects_1.put)(slice_2.balanceProviderActions.fetchPaymentMethodsSuccess(resData));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        yield (0, effects_1.put)(slice_2.balanceProviderActions.fetchPaymentMethodsError(error));
    }
}
function* fetchPaymentAccountsSaga() {
    try {
        const paymentsApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.PaymentsApi);
        const currentMethod = yield (0, effects_1.select)(selectors_2.selectCurrentWithdrawalMethod);
        const accountId = yield (0, effects_1.select)(selectors_1.selectAccountId);
        const { data: resData } = yield (0, effects_1.call)(() => paymentsApi.getPaymentAccounts({
            methodId: currentMethod.id,
            accountId,
        }));
        yield (0, effects_1.put)(slice_2.balanceProviderActions.fetchPaymentAccountsSuccess({
            resData,
            methodId: currentMethod.id,
        }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        yield (0, effects_1.put)(slice_2.balanceProviderActions.fetchPaymentAccountsError(error));
    }
}
function* createPaymentSaga() {
    try {
        const paymentsApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.PaymentsApi);
        const currentMethod = yield (0, effects_1.select)(selectors_5.selectCurrentPaymentMethod);
        const formData = yield (0, effects_1.select)(selectors_2.selectPaymentFormData);
        const account = yield (0, effects_1.select)(selectors_1.selectAccount);
        const originUrl = env_1.isReactNative
            ? yield (0, effects_1.select)(selectors_2.selectOriginUrl)
            : window.location.origin;
        const config = yield (0, effects_1.select)(selectors_4.selectConfig);
        // TODO replace with route enums
        const paymentRedirectPath = config.CLIENT_TYPE === types_2.EClientTypes.WEB_DESKTOP
            ? 'profile/balance'
            : 'profile/top-up';
        const { data: resData } = yield (0, effects_1.call)(() => paymentsApi.createWebPayment({
            newWebPayment: {
                amount: (0, format_1.adjustAmountForBackend)(formData.amount),
                accountId: account.id,
                providerId: currentMethod.providerId,
                methodId: currentMethod.id,
                currencyId: account.currencyId,
                successRedirectUrl: `${originUrl}/${paymentRedirectPath}/?${constants_1.PAYMENT_QUERY_PARAM}=${types_1.EPaymentModalTypes.Success}`,
                failRedirectUrl: `${originUrl}/${paymentRedirectPath}/?${constants_1.PAYMENT_QUERY_PARAM}=${types_1.EPaymentModalTypes.Canceled}`,
            },
        }));
        yield (0, effects_1.put)(slice_2.balanceProviderActions.createPaymentSuccess(resData));
        // TODO remove React Native specific logic
        if (!env_1.isReactNative) {
            yield (0, effects_1.put)(slice_2.balanceProviderActions.resetPaymentFormData());
        }
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        yield (0, effects_1.put)(slice_2.balanceProviderActions.createPaymentError(error));
    }
}
function* fetchWithdrawalsSaga(action) {
    try {
        const withdrawalsApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.WithdrawalsApi);
        const { data: resData } = yield (0, effects_1.call)(() => withdrawalsApi.getWithdrawals(action.payload));
        yield (0, effects_1.put)(slice_2.balanceProviderActions.fetchWithdrawalsSuccess(resData));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        yield (0, effects_1.put)(slice_2.balanceProviderActions.fetchWithdrawalsError(error));
    }
}
function* fetchWithdrawalMethodsSaga(action) {
    try {
        const withdrawalsApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.WithdrawalsApi);
        const currentLangCode = yield (0, effects_1.select)(selectors_3.selectCurrentLangCode);
        const accountId = yield (0, effects_1.select)(selectors_1.selectAccountId);
        const reqPayload = { locale: currentLangCode, accountId };
        const { data: resData } = yield (0, effects_1.call)(() => withdrawalsApi.getWithdrawalMethods({ ...action.payload, ...reqPayload }));
        yield (0, effects_1.put)(slice_2.balanceProviderActions.fetchWithdrawalMethodsSuccess(resData));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        yield (0, effects_1.put)(slice_2.balanceProviderActions.fetchWithdrawalMethodsError(error));
    }
}
function* createWithdrawalSaga() {
    try {
        const withdrawalsApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.WithdrawalsApi);
        const currentMethod = yield (0, effects_1.select)(selectors_2.selectCurrentWithdrawalMethod);
        const currentPaymentAccount = yield (0, effects_1.select)(selectors_2.selectCurrentPaymentAccount);
        const formData = yield (0, effects_1.select)(selectors_2.selectWithdrawalFormData);
        const account = yield (0, effects_1.select)(selectors_1.selectAccount);
        const verificationId = yield (0, effects_1.select)(selectors_2.selectWithdrawalVerificationId);
        const verificationCode = yield (0, effects_1.select)(selectors_2.selectWithdrawalSmsCode);
        const withdrawParams = (0, utils_1.mapWithdrawMethodParams)({
            methodParamsList: currentMethod.withdraw_params,
            formData,
            paymentAccount: currentPaymentAccount,
        });
        const { data: resData } = yield (0, effects_1.call)(() => withdrawalsApi.createWithdrawalTransaction({
            newWithdrawal: {
                amount: (0, format_1.adjustAmountForBackend)(formData.amount),
                accountId: account.id,
                providerId: currentMethod.providerId,
                methodId: currentMethod.id,
                currencyId: account.currencyId,
                parameters: withdrawParams,
            },
            verificationId,
            verificationCode,
        }));
        yield (0, effects_1.put)(slice_2.balanceProviderActions.createWithdrawalSuccess(resData));
    }
    catch (e) {
        yield (0, effects_1.put)(slice_2.balanceProviderActions.createWithdrawalError(e));
    }
}
function* createWithdrawalSuccessSideEffectsSaga() {
    yield (0, effects_1.put)(slice_2.balanceProviderActions.changeWithdrawModal({
        modalType: types_1.EBalanceWithdrawModalWindowType.SUCCESS,
    }));
    yield (0, effects_1.delay)(2000); // To fetch up-to-date balance
    yield (0, effects_1.put)(slice_1.accountProviderActions.getDefaultAccount());
}
function* fetchPaymentMethodGroupsSaga() {
    try {
        const paymentMethodGroupsApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.PaymentMethodGroupsApi);
        const currentLangCode = yield (0, effects_1.select)(selectors_3.selectCurrentLangCode);
        const reqPayload = { locale: currentLangCode };
        const { data } = yield (0, effects_1.call)(() => paymentMethodGroupsApi.getPaymentMethodGroups(reqPayload));
        yield (0, effects_1.put)(slice_2.balanceProviderActions.fetchPaymentMethods({}));
        yield (0, effects_1.put)(slice_2.balanceProviderActions.fetchWithdrawalMethods({}));
        yield (0, effects_1.put)(slice_2.balanceProviderActions.fetchPaymentMethodGroupsSuccess(data));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        yield (0, effects_1.put)(slice_2.balanceProviderActions.fetchPaymentMethodGroupsError(error));
    }
}
function* fetchVerificationIdentifierSaga() {
    try {
        const verificationsApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.VerificationsApi);
        const currentMethod = yield (0, effects_1.select)(selectors_2.selectCurrentWithdrawalMethod);
        const currentPaymentAccount = yield (0, effects_1.select)(selectors_2.selectCurrentPaymentAccount);
        const formData = yield (0, effects_1.select)(selectors_2.selectWithdrawalFormData);
        const account = yield (0, effects_1.select)(selectors_1.selectAccount);
        const withdrawParams = (0, utils_1.mapWithdrawMethodParams)({
            methodParamsList: currentMethod.withdraw_params,
            formData,
            paymentAccount: currentPaymentAccount,
        });
        const newWithdrawal = {
            amount: (0, format_1.adjustAmountForBackend)(formData.amount),
            accountId: account.id,
            providerId: currentMethod.providerId,
            methodId: currentMethod.id,
            currencyId: account.currencyId,
            parameters: withdrawParams,
        };
        const newVerification = {
            requestBody: JSON.stringify(newWithdrawal),
            type: betweb_openapi_axios_1.VerificationType.Withdrawal,
            provider: betweb_openapi_axios_1.VerificationProvider.SmsCode,
        };
        const { data } = yield (0, effects_1.call)(() => verificationsApi.createVerificationRequest({ newVerification }));
        yield (0, effects_1.put)(slice_2.balanceProviderActions.fetchVerificationIdentifierSuccess(data));
        yield (0, effects_1.put)(slice_2.balanceProviderActions.changeWithdrawModal({
            modalType: types_1.EBalanceWithdrawModalWindowType.SMS,
        }));
    }
    catch (e) {
        if (e.response.status === 429) {
            yield (0, effects_1.put)(slice_2.balanceProviderActions.changeWithdrawModal({
                modalType: types_1.EBalanceWithdrawModalWindowType.SMS,
            }));
        }
        else {
            yield (0, effects_1.put)(slice_2.balanceProviderActions.changeWithdrawModal({
                modalType: types_1.EBalanceWithdrawModalWindowType.ERROR,
            }));
        }
        yield (0, effects_1.put)(slice_2.balanceProviderActions.fetchVerificationIdentifierError(e));
        // yield withdrawVerificationIdentifierErrorSaga(e)
    }
}
// discuss
function* withdrawVerificationIdentifierErrorSaga(errors) {
    var _a, _b, _c;
    const code = (_b = (_a = errors.response.data) === null || _a === void 0 ? void 0 : _a.errors[0]) === null || _b === void 0 ? void 0 : _b.code;
    if (code) {
        const title = (_c = constants_1.ALL_WITHDRAW_ERROR_MESSAGES[code]) !== null && _c !== void 0 ? _c : 'error';
        const error = {
            title,
            code,
            reasons: [],
            message: '',
        };
        yield (0, effects_1.put)(slice_2.balanceProviderActions.fetchVerificationIdentifierError(error));
    }
}
function* BalanceProviderSaga() {
    yield (0, effects_1.all)([
        (0, effects_1.takeLatest)(slice_2.balanceProviderActions.fetchPayments.type, fetchPaymentsSaga),
        (0, effects_1.takeLatest)(slice_2.balanceProviderActions.fetchPaymentAccounts.type, fetchPaymentAccountsSaga),
        (0, effects_1.takeLatest)(slice_2.balanceProviderActions.fetchPaymentMethods.type, fetchPaymentMethodsSaga),
        (0, effects_1.takeLatest)(slice_2.balanceProviderActions.createPayment.type, createPaymentSaga),
        (0, effects_1.takeLatest)(slice_2.balanceProviderActions.fetchWithdrawals.type, fetchWithdrawalsSaga),
        (0, effects_1.takeLatest)(slice_2.balanceProviderActions.fetchWithdrawalMethods.type, fetchWithdrawalMethodsSaga),
        (0, effects_1.takeLatest)(slice_2.balanceProviderActions.createWithdrawal.type, createWithdrawalSaga),
        (0, effects_1.takeLatest)(slice_2.balanceProviderActions.createWithdrawalSuccess, createWithdrawalSuccessSideEffectsSaga),
        (0, effects_1.takeLatest)(slice_2.balanceProviderActions.fetchPaymentMethodGroups.type, fetchPaymentMethodGroupsSaga),
        (0, effects_1.takeLatest)(slice_2.balanceProviderActions.fetchVerificationIdentifier.type, fetchVerificationIdentifierSaga),
    ]);
}
//# sourceMappingURL=saga.js.map